import { useEffect, useRef, useState } from 'react'
import { Avatar } from '../ui/Avatar'
import { useAuth } from '../../context/AuthContext'
import { useTheme } from '../../context/ThemeContext'
import { ProfileModalContent } from '../../features/profile/ProfileModalContent'
import { PasswordModalContent } from '../../features/profile/PasswordModalContent'
import { useModal } from '../../context/ModalContext'

export function UserMenu() {
  const { session, logout } = useAuth()
  const { theme, toggleTheme } = useTheme()
  const { openCustom } = useModal()
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function onClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('click', onClick)
    return () => document.removeEventListener('click', onClick)
  }, [])

  if (!session) return null

  return (
    <div className="relative" ref={ref}>
      <button
        className="flex items-center gap-2 rounded-[10px] border border-line bg-panel-2 px-2.5 py-1.5 font-semibold text-text"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <Avatar name={session.name} src={session.avatar} />
        <span className="text-muted">{session.name}</span>
        <span className="text-xs text-muted">▾</span>
      </button>
      {open && (
        <div
          role="menu"
          className="absolute top-[calc(100%+8px)] right-0 z-30 flex min-w-[210px] flex-col rounded-xl border border-line bg-panel p-1.5 shadow-[0_10px_30px_#000a]"
        >
          <button
            role="menuitem"
            className="rounded-lg px-3 py-2.5 text-left text-sm text-text hover:bg-panel-2"
            onClick={() => {
              setOpen(false)
              openCustom({ title: 'Perfil', render: (close) => <ProfileModalContent onDone={close} /> })
            }}
          >
            👤 Perfil
          </button>
          <button
            role="menuitem"
            className="rounded-lg px-3 py-2.5 text-left text-sm text-text hover:bg-panel-2"
            onClick={() => {
              setOpen(false)
              openCustom({
                title: 'Cambiar contraseña',
                render: (close) => <PasswordModalContent onDone={close} />,
              })
            }}
          >
            🔒 Cambiar contraseña
          </button>
          <button
            role="menuitem"
            className="rounded-lg px-3 py-2.5 text-left text-sm text-text hover:bg-panel-2"
            onClick={toggleTheme}
          >
            {theme === 'dark' ? '🌙 Tema oscuro' : '☀️ Tema claro'}
          </button>
          <button
            role="menuitem"
            className="rounded-lg px-3 py-2.5 text-left text-sm text-[#ff8d9a] hover:bg-panel-2"
            onClick={() => {
              setOpen(false)
              logout()
            }}
          >
            Salir
          </button>
        </div>
      )}
    </div>
  )
}
